(ns web3.persistence.transit
  (:require [cognitect.transit :as t]
            [clojure.string :as string]))

(def reader (t/reader :json))
(def writer (t/writer :json))

(defn read [x]
  (t/read reader x))

(defn write [x]
  (t/write writer x))

(defn deserialize [x]
  (when (and (string? x) (string/starts-with? x "transit/json:"))
    (read (subs x 13))))

(defn serialize [x]
  (str "transit/json:" (write x)))
